import React from "react";
import classNames from "classnames";
import { capitalize } from "lodash";
import Chip from "./Chip";
import { FulfillmentDisplayStatus } from "gpc-shared-types";

export type Props = {
  status: FulfillmentDisplayStatus | string;
  count: number;
  className?: string;
};

const getStatusColor = (status: FulfillmentDisplayStatus | string) => {
  switch (status) {
    case FulfillmentDisplayStatus.FAILURE:
      return "danger";

    case FulfillmentDisplayStatus.ATTEMPTED_DELIVERY:
    case FulfillmentDisplayStatus.DELAYED:
      return "warning";

    case FulfillmentDisplayStatus.DELIVERED:
    case FulfillmentDisplayStatus.MARKED_AS_FULFILLED:
    case FulfillmentDisplayStatus.FULFILLED:
    case FulfillmentDisplayStatus.PICKED_UP:
      return "success";

    default:
      return;
  }
};

const getStatusLabel = (status: FulfillmentDisplayStatus | string) => {
  switch (status) {
    case FulfillmentDisplayStatus.MARKED_AS_FULFILLED:
      return "Fulfilled";
    default:
      return status;
  }
};

export const FulfillmentStatus = ({ status, count, className = "" }: Props) => {
  const internalClassName = classNames("gpc__fulfillment-status", className);

  const label =
    capitalize(getStatusLabel(status).replace(/_/g, " ")) + ` (${count})`;

  return (
    <div className={internalClassName}>
      <Chip label={label} color={getStatusColor(status)} />
    </div>
  );
};

export default FulfillmentStatus;
